import { combineReducers } from "redux-immutable";

import UserStatStateSlice from "../../models/state/userStats";
import { userStatsMeta } from "./state/meta";
import { userStats } from "./state/stat";

export default combineReducers(
  {
    meta: userStatsMeta,
    stats: userStats
  },
  () => new UserStatStateSlice() as any
);
